// extracted by mini-css-extract-plugin
export var LanguageSelector = "languageselector-module--LanguageSelector--22Cdw";